import breakpoints from '@/scss/01-settings/_settings.breakpoints.scss';

export const getBreakpoints = () =>
  Object.fromEntries(
    Object.entries(breakpoints).map(([name, breakpointInPixels]) => [
      name,
      Number(breakpointInPixels.replace('px', '')),
    ]),
  );

export const getBreakpointsWithMinMaxValues = () =>
  Object.entries(getBreakpoints())
    .reduce(
      (previousValue, [name, min], index) => [
        ...previousValue,
        {
          name,
          min: index === 0 ? 0 : min,
        },
      ],
      [],
    )
    .map((item, index, array) => ({
      ...item,
      max: array[index + 1]?.min || Number.POSITIVE_INFINITY,
    }));
